var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.8723,
    width: 3.00896,
    height: 32.3464,
    rx: 1.50448,
    transform: "rotate(45 22.8723 0)",
    fill: "#444444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2.25684,
    width: 3.00896,
    height: 32.3464,
    rx: 1.50448,
    transform: "rotate(-45 0 2.25684)",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelSchedule);
export default __webpack_public_path__ + "static/media/icon-cancel-schedule.ca99e34a9f5a389da2bc00ff31f91ad5.svg";
export { ForwardRef as ReactComponent };